import {configureStore} from '@reduxjs/toolkit'
import authReducer from '../feature/auth/authSlice'
import interviewReducer from '../feature/interview/interviewSlice'

export const store = configureStore({
    reducer:{
        auth: authReducer,
        interview:interviewReducer
    }
})
